export default __webpack_public_path__ + "media/images/decompte-conges-vert-14c211e314ec8aca7c1f926fc94f316e.png";